var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPmgIntelligenceLogoFullColourRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PMG_Intelligence_Logo_FullColour_RGB 1",
    clipPath: "url(#clip0_739_11066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0.128998H3.735C5.412 0.128998 6.33 1.257 6.33 2.61C6.33 3.951 5.412 5.058 3.735 5.058H1.923V7.584H0V0.128998ZM3.477 1.749H1.923V3.426H3.477C3.99 3.426 4.371 3.102 4.371 2.598C4.371 2.085 3.99 1.749 3.477 1.749Z",
    fill: "#042231"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.703 0.128998C22.335 0.128998 23.343 0.932998 23.889 1.863L22.278 2.712C21.975 2.22 21.405 1.83 20.703 1.83C19.485 1.83 18.624 2.769 18.624 3.987C18.624 5.205 19.485 6.144 20.703 6.144C21.285 6.144 21.81 5.943 22.113 5.697V5.07H20.403V3.471H24.003V6.39C23.199 7.272 22.113 7.842 20.706 7.842C18.48 7.842 16.671 6.354 16.671 3.984C16.665 1.617 18.477 0.128998 20.703 0.128998Z",
    fill: "#042231"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.872 0.122986L11.451 3.78899L9.03 0.122986H7.413L7.41 7.58699H9.348L9.351 4.40699L11.451 7.06799L13.554 4.40699L13.548 7.58699H15.486L15.489 0.122986H13.872Z",
    fill: "#3A82D4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_739_11066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 11.553,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmgIntelligenceLogoFullColourRgb);
export default __webpack_public_path__ + "static/media/PMG_Intelligence_Logo_FullColour_RGB.ede7db4b82b2d295a4be31bfa87a7bd5.svg";
export { ForwardRef as ReactComponent };